// src/store/uiSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UiState {
  globalSuccess: string | null;
  globalError: string | null;
}

const initialState: UiState = {
  globalSuccess: null,
  globalError: null,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    showSuccess(state, action: PayloadAction<string>) {
      state.globalSuccess = action.payload;
      state.globalError = null;
    },
    showError(state, action: PayloadAction<string>) {
      state.globalError = action.payload;
      state.globalSuccess = null;
    },
    clearMessages(state) {
      state.globalSuccess = null;
      state.globalError = null;
    },
  },
});

export const { showSuccess, showError, clearMessages } = uiSlice.actions;
export default uiSlice.reducer;
